import { AxiosInstance } from "axios";
import { Purchase } from "../models/purchase";

const CHECKOUT_API_PREFIX = "/payments/invoice";

export const getUserPurchaseHistory = async (
	http: AxiosInstance
): Promise<Purchase[]> => {
	const response = await http.get<Purchase[]>(
		`${CHECKOUT_API_PREFIX}/purchase-history`
	);

	return response.data;
};
